import {createSelector} from 'reselect';

export const getSuggestions = state => state.suggestions || {};

export const getSuggestionsArray = createSelector(
  [getSuggestions],
  suggestions => Object.values(suggestions)
);

export const getSuggestionById = state => id => {
  return state.suggestions[id];
};
